const ResumeTypes = {
    FETCH_START:    '[MANAGERS][RESUME] FETCH START',
    FETCH_SUCCESS:  '[MANAGERS][RESUME] FETCH SUCCESS',
    FETCH_FAILURE:  '[MANAGERS][RESUME] FETCH FAILURE'
};

export default ResumeTypes;